import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  selectPermissions,
  selectRole,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
} from '../utils/permissions';

export function usePermissions() {
  const permissions = useSelector(selectPermissions);
  const role = useSelector(selectRole);

  const can = (permission) => hasPermission(permissions, permission);

  const guard = (permission, action) => {
    if (!can(permission)) {
      toast.error('You are not authorized to perform this action.');
      return Promise.resolve(undefined);
    }
    return Promise.resolve(action());
  };

  return {
    permissions,
    role,
    can,
    canAny: (list) => hasAnyPermission(permissions, list),
    canAll: (list) => hasAllPermissions(permissions, list),
    guard,
  };
}

export default usePermissions;
